export default __webpack_public_path__ + "static/media/koala.c34d1507.jpg";